import { Box } from "@material-ui/core";
import CopyrightIcon from "@material-ui/icons/Copyright";

const Footer = () => (
  <footer>
    <Box display="flex" justifyContent="center">
      <CopyrightIcon /> 2022 Felicia von Braun
    </Box>
  </footer>
);
export default Footer;
